export const assets: Record<string, any> = {
    tel: 'file-asset/file/61e91072a8f9f21fafbc291bb09256a2.svg',
    email: 'file-asset/file/8b94cfd98213dd9ac6fe1f2cedf5d08a.svg',
    user: 'file-asset/file/53a2a9353415a4558f74f707e58b4873.svg',
    cart: 'file-asset/file/f4ad01ed03d046e4faa7bcb68b23b066.svg',
    location: 'file-asset/file/ab47478931e256c18b7078180ac0322b.svg',
    logo: {
        default: 'file-asset/file/e163d929c0053f151efd3f4548230530.svg',
        darkIcon: 'file-asset/file/7cee026b9a9ff04ed8fcdf4c5c2a847e.svg',
        darkText: 'file-asset/file/d526d65681aa532f713457bfd36cd730.svg',
        light: 'file-asset/file/7200303da8da9c7630fa5e93e0c96f57.svg',
        lightIcon: 'file-asset/file/189de8a5d855eca6f494a710ad973563.svg',
        lightText: 'file-asset/file/b103a248601316ab7bd20369a6c72de9.svg',
    },
    sns: {
        facebook: 'file-asset/file/18ac2cb592417ceb58ff7f79b56def32.svg',
        x: 'asset/width-126/picture/d18a8ade7b257d392218f4fc5cfaea72.png',
        whatsApp: 'asset/width-126/picture/7b618732dbeabeb64a1826518e20594d.png',
    }
};